/** Windows Settings pages that host the GPU options this feature asks users to change. */
const WINDOWS_SETTINGS_DEEP_LINKS = {
    graphicsSettings: "ms-settings:display-advancedgraphics",
    defaultGraphicsSettings: "ms-settings:display-advancedgraphics-default",
};

/** Windows Settings > System > Display > Graphics (per-app GPU preference). */
export function openGraphicsSettings() {
    openWindowsSettings(WINDOWS_SETTINGS_DEEP_LINKS.graphicsSettings);
}

/** Windows Settings > ... > Graphics > Default graphics settings (HAGS, windowed games). */
export function openDefaultGraphicsSettings() {
    openWindowsSettings(WINDOWS_SETTINGS_DEEP_LINKS.defaultGraphicsSettings);
}

/**
 * Must be called from a user gesture (a click), not from the DevTools console: Chrome only
 * hands a URL to an external protocol handler while the page holds transient user activation,
 * and it refuses to let a cross-origin iframe — which is how the viewer runs inside Procore —
 * navigate itself to one. Hence the new-context anchor click rather than a location assignment.
 */
function openWindowsSettings(uri: string) {
    if (userActivationIsActive() === false) {
        console.warn(`[GPU guidance] No user activation, so Chrome will drop ${uri}.`);
        return;
    }

    try {
        const anchor = document.createElement("a");
        anchor.href = uri;
        anchor.target = "_blank";
        anchor.rel = "noopener";
        anchor.style.display = "none";
        document.body.append(anchor);
        anchor.click();
        anchor.remove();
    } catch (error) {
        console.warn(`[GPU guidance] Could not launch ${uri}.`, error);
    }
}

/** `undefined` when the browser does not expose the User Activation API. */
function userActivationIsActive(): boolean | undefined {
    return (navigator as Navigator & { userActivation?: { isActive: boolean } }).userActivation?.isActive;
}
